import TYPES from '../actions/types';

const INITIAL_STATE = {
    list: [],
    paging: {},
    filter: {},
    selected: null
};

export const organizerReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case TYPES.SET_ORGANIZERS:
            const { count, current, page, pageCount, sort, direction } = action.payload.paging;
            return {
                ...state, 
                list: action.payload.list, 
                paging: { count, current, page, pageCount, sort, direction }
            };

        case TYPES.SELECT_ORGANIZER:
            return {
                ...state,
                selected: action.payload
            };

        case TYPES.SET_ORGANIZER_FILTER:
            return {
                ...state,
                filter: action.payload,
                paging: {}
            };
        
        default:
            return state;
    }

};